"use client";

import { useTranslations } from "next-intl";
import { ArrowLeft } from "lucide-react";

export function TermsPage() {
  const t = useTranslations("legal");

  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <button
          onClick={() => window.history.back()}
          className="mb-8 inline-flex items-center gap-2 text-base text-ink-mute transition-colors hover:text-ink"
        >
          <ArrowLeft size={20} />
          {t("back")}
        </button>

        <h1 className="text-3xl font-bold tracking-tight text-ink">
          {t("terms.title")}
        </h1>
        <p className="mt-2 text-sm text-ink-mute">
          {t("terms.lastUpdated")}
        </p>

        <div className="mt-8 space-y-8">
          <Section title={t("terms.introTitle")}>
            <p>{t("terms.introText")}</p>
          </Section>

          <Section title={t("terms.serviceTitle")}>
            <p>{t("terms.serviceText")}</p>
          </Section>

          <Section title={t("terms.accountTitle")}>
            <p>{t("terms.accountText")}</p>
          </Section>

          <Section title={t("terms.contentTitle")}>
            <p>{t("terms.contentText")}</p>
          </Section>

          <Section title={t("terms.aiTitle")}>
            <p>{t("terms.aiText")}</p>
          </Section>

          <Section title={t("terms.paymentTitle")}>
            <p>{t("terms.paymentText")}</p>
          </Section>

          <Section title={t("terms.prohibitedTitle")}>
            <p>{t("terms.prohibitedText")}</p>
            <ul className="mt-3 list-disc space-y-1 pl-5">
              <li>{t("terms.prohibitedItem1")}</li>
              <li>{t("terms.prohibitedItem2")}</li>
              <li>{t("terms.prohibitedItem3")}</li>
              <li>{t("terms.prohibitedItem4")}</li>
              <li>{t("terms.prohibitedItem5")}</li>
            </ul>
          </Section>

          <Section title={t("terms.disclaimerTitle")}>
            <p>{t("terms.disclaimerText")}</p>
          </Section>

          <Section title={t("terms.liabilityTitle")}>
            <p>{t("terms.liabilityText")}</p>
          </Section>

          <Section title={t("terms.terminationTitle")}>
            <p>{t("terms.terminationText")}</p>
          </Section>

          <Section title={t("terms.changesTitle")}>
            <p>{t("terms.changesText")}</p>
          </Section>

          <Section title={t("terms.contactTitle")}>
            <p>{t("terms.contactText")}</p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section>
      <h2 className="text-lg font-semibold text-ink">{title}</h2>
      <div className="mt-2 text-sm leading-relaxed text-ink-dim">
        {children}
      </div>
    </section>
  );
}
